<template>
  <tr >
    <td>{{contact.contact_id}}</td>
    <td>{{contact.created_at}}</td>
    <td>{{contact.name}}</td>
<!--    <td>{{contact.tel}}</td>-->
    <td>{{contact.mail}}</td>
    <td>{{contact.detail}}</td>
  </tr>
</template>
<script>
  export default {
    props: ['contact']
  }
</script>



// WEBPACK FOOTER //
// ListRow.vue?1f449432